import api from '@/lib/api';

export interface ExternalTicket {
  id: string;
  ticket_number: string;
  subject: string;
  description?: string;
  status: 'open' | 'pending' | 'solved' | 'closed';
  priority: 'low' | 'normal' | 'high' | 'urgent';
  requester_id: string;
  assignee_id?: string;
  organization_id: string;
  ticket_type: 'external';
  parent_ticket_id: string;
  created_at: string;
  updated_at: string;
  metadata?: {
    external_party_name?: string;
    external_party_email?: string;
    external_party_company?: string;
    external_type?: string;
  };
  requester_name?: string;
  requester_email?: string;
  assignee_name?: string;
  assignee_email?: string;
}

export interface CreateExternalTicketRequest {
  title: string;
  description?: string;
  external_party_name: string;
  external_party_email: string;
  external_party_company?: string;
  priority?: 'low' | 'normal' | 'high' | 'urgent';
  type?: 'supplier' | 'warehouse' | 'shipping' | 'vendor' | 'partner' | 'other';
}

export interface ExternalTicketsResponse {
  success: boolean;
  data: {
    parentTicketId: string;
    externalTickets: ExternalTicket[];
  };
}

export interface CreateExternalTicketResponse {
  success: boolean;
  message: string;
  data: {
    ticket: ExternalTicket;
    external_party: {
      name: string;
      email: string;
      company?: string;
      type: string;
    };
  };
}

const externalTicketsService = {
  // Get external tickets for a parent ticket
  async getByParentTicketId(parentTicketId: string): Promise<ExternalTicket[]> {
    const response = await api.get<ExternalTicketsResponse>(`/tickets/${parentTicketId}/externals`);
    return response.data.data.externalTickets;
  },

  // Create new external ticket
  async create(parentTicketId: string, ticketData: CreateExternalTicketRequest): Promise<ExternalTicket> {
    const response = await api.post<CreateExternalTicketResponse>(`/tickets/${parentTicketId}/external`, ticketData);
    return response.data.data.ticket;
  }
};

export default externalTicketsService;